import React from "react";

function Question(props) {
  return (
    <>
      <p className="text-large">{props.question}</p>
      {props.img ? <img src={props.img} alt="" className="img-quiz" /> : null}
    </>
  );
}

export default Question;
